export function PromptConstraints() {
  return (
    <div className='flex flex-col gap-6 p-4'>
      <div className='flex flex-col gap-1'>
        <h4 className='text-sm font-semibold text-neutral-950'>Prompt configuration</h4>
        <p className='text-xs text-neutral-600'>Prompts do not support additional properties at this time.</p>
      </div>
    </div>
  );
}
